import { type MobileLayoutPages } from '../types';
import MobileInitPage from './MobileInitPage';
import MobileAuthPage from './MobileAuthPage';
import MobileWaitingPage from './MobileWaitingPage';
import MobileAgentStartPage from './MobileAgentStartPage';
import MobileAppPairingPage from './MobileAppPairingPage';
import MobileAppPresentationPage from './MobileAppPresentationPage';
import MobileDonePage from './MobileDonePage';
import MobileAbortPage from './MobileAbortPage';
import MobileFlowStartPage from './MobileFlowStartPage';
import MobileAppPickerPage from './MobileAppPickerPage';
import MobileIssuanceReviewPage from './MobileIssuanceReviewPage';
import MobileAppInstallPage from './MobileAppInstallPage';

export const mobilePages: MobileLayoutPages = {
  Init: MobileInitPage,
  Auth: MobileAuthPage,
  WaitingForPresentation: MobileWaitingPage,
  AgentStart: MobileAgentStartPage,
  AppPairing: MobileAppPairingPage,
  AppPresentation: MobileAppPresentationPage,
  Done: MobileDonePage,
  Abort: MobileAbortPage,
  FlowStart: MobileFlowStartPage,
  AppPicker: MobileAppPickerPage,
  IssuanceReview: MobileIssuanceReviewPage,
  AppInstall: MobileAppInstallPage,
};

export { default as MobileFlowStartPage } from './MobileFlowStartPage';
export { default as MobileAppPickerPage } from './MobileAppPickerPage';
export { default as MobileIssuanceReviewPage } from './MobileIssuanceReviewPage';
export { default as MobileAppInstallPage } from './MobileAppInstallPage';
